import axios from "axios";

class PentestService {
  getListPentest(page, pageSize, status) {
    let url = `/pentest?page=${page}&pageSize=${pageSize}`;
    if(status){
     url = `/pentest?page=${page}&pageSize=${pageSize}&status=${status}`;
    }
    return axios.get(url);
  }
  getPentestByID(id) {
    return axios.get(`/pentest/${id}`);
  }
  postPentest(payload) {
    return axios.post(`pentest`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  updatePentest(payload, id) {
    return axios.put(`pentest/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  deletePentest(id) {
    return axios.delete(`/pentest/${id}`);
  }
}

export default new PentestService();
